import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaEnvelope } from 'react-icons/fa';
import './App.css';
import logo from './assets/logo.png';
import hidevLogo from './assets/hidev_logo.png';
import SMPPage from './pages/SMPPage';
import SanFranciscoPage from './pages/SanFranciscoPage';
import SanJosePage from './pages/SanJosePage';
import LocationCard from './components/LocationCard';
import { services } from './data/services';
import { locations } from './data/locations';
import ScrollToTop from './components/ScrollToTop';
import Footer from './components/Footer';
import Header from './components/Header';

const HomePage: React.FC = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  return (
    <div className="App">
      <Header>
        <a href="#about">About</a>
        <a href="#services">Services</a>
        <Link to="/smp">SMP</Link>
        <Link to="/san-francisco">San Francisco</Link>
        <Link to="/san-jose">San Jose</Link>
      </Header>

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-container">
          <div className="hero-content">
            <h1>Your Trusted Neighborhood Barber</h1>
            <p>Experience the finest in classic barbering in San Francisco & San Jose</p>
            <div className="hero-buttons">
              <a href="#locations" className="btn btn-primary">Choose Location</a>
              <a href="#services" className="btn btn-secondary">View Services</a>
            </div>
          </div>
          <div className="hero-video-container">
            <div className="hero-video">
              <div className="hero-video-caption hero-video-caption-top">
                METROPOLITAN BARBERSHOP
              </div>
              <iframe
                src="https://player.vimeo.com/video/1093218818?h=b336995271&badge=0&autopause=0&player_id=0&app_id=58479&autoplay=1&loop=1&controls=0&title=0&byline=0&portrait=0&muted=1"
                title="metro-hero"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                allowFullScreen
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
              ></iframe>
              <div className="hero-video-caption hero-video-caption-bottom">
                EST. 2015 • THE BAY AREA'S FINEST BARBERSHOP
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="about">
        <div className="container">
          <div className="about-content">
            <div className="about-text">
              <h2>About Metropolitan Barbershop</h2>
              <p>
                Metropolitan is a classic barbershop focused on providing a unique experience and improving your appearance along the way. We specialize in all mens haircuts: Tapers, fades, sideparts, etc.. If you can't explain it bring in a picture.
              </p>
              <p>
                Now with two locations in the Bay Area - our original shop in the Nob Hill neighborhood of San Francisco and our new location in San Jose. Come in and enjoy an ice cold beer, talk some shit, and get cleaned up.
              </p>
            </div>
            <div className="about-image">
              <img src="https://images.unsplash.com/photo-1585747860715-2ba37e788b70?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80" alt="Barbershop interior" />
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="services">
        <div className="container">
          <h2>Our Services</h2>
          <p>Available at both locations</p>
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className={`service-card ${service.isSpecial ? 'service-card-special' : ''}`}>
                <div className="service-image">
                  <img src={service.image} alt={service.name} />
                </div>
                <div className="service-content">
                  <div className="service-header">
                    <h3>{service.name}</h3>
                    <span className="price">{service.price}</span>
                  </div>
                  <p>{service.description}</p>
                  {service.isSpecial && service.linkTo && (
                    <div className="service-cta">
                      <Link to={service.linkTo} className="btn btn-primary">Learn More</Link>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Locations Section */}
      <section id="locations" className="locations">
        <div className="container">
          <h2>Our Locations</h2>
          <p>Choose your preferred location to book and learn more</p>
          <div className="locations-grid">
            {locations.map((location, index) => (
              <LocationCard key={index} location={location} />
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/smp" element={<SMPPage />} />
        <Route path="/san-francisco" element={<SanFranciscoPage />} />
        <Route path="/san-jose" element={<SanJosePage />} />
      </Routes>
    </Router>
  );
}

export default App;
